import { render, staticRenderFns } from "./ModalPlayVoice.vue?vue&type=template&id=744974b0&scoped=true&"
import script from "./ModalPlayVoice.vue?vue&type=script&lang=js&"
export * from "./ModalPlayVoice.vue?vue&type=script&lang=js&"
import style0 from "./ModalPlayVoice.vue?vue&type=style&index=0&id=744974b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744974b0",
  null
  
)

export default component.exports